import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "33",
  height: "33",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.023 13.275c0-.536.432-.971.964-.971h5.14c.533 0 .965.435.965.971a.97.97 0 0 1-.964.972h-5.14a.97.97 0 0 1-.965-.972"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M28.749 13.794a4 4 0 0 0-.267-.005h-3.698c-3.029 0-5.62 2.315-5.62 5.333s2.591 5.334 5.62 5.334h3.698q.141.001.267-.005c1.23-.076 2.318-1.01 2.41-2.316.005-.086.005-.178.005-.264v-5.498c0-.085 0-.178-.006-.263-.091-1.306-1.18-2.24-2.41-2.316m-4.29 6.75c.779 0 1.41-.636 1.41-1.422s-.631-1.422-1.41-1.422c-.78 0-1.413.637-1.413 1.422 0 .786.633 1.423 1.412 1.423",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M28.683 13.792c0-1.574-.057-3.263-1.063-4.474q-.145-.175-.31-.34c-.999-.998-2.264-1.44-3.827-1.65-1.52-.205-3.46-.205-5.91-.205h-2.818c-2.45 0-4.39 0-5.91.204-1.563.21-2.828.653-3.826 1.651s-1.44 2.263-1.65 3.826c-.205 1.52-.205 3.46-.205 5.91v.15c0 2.451 0 4.392.204 5.911.21 1.563.653 2.829 1.651 3.826.998.998 2.263 1.441 3.826 1.651 1.52.204 3.46.204 5.91.204h2.818c2.45 0 4.39 0 5.91-.204 1.563-.21 2.828-.653 3.826-1.65.273-.273.504-.566.701-.88.6-.96.673-2.136.673-3.268q-.097.002-.201.002h-3.698c-3.029 0-5.62-2.314-5.62-5.333 0-3.018 2.591-5.333 5.62-5.333h3.698q.105 0 .201.002",
      opacity: ".5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.972 3.886 11.17 5.78 8.86 7.326c1.517-.203 3.456-.203 5.902-.203h2.817c2.45 0 4.391 0 5.91.204q.459.06.883.153l-2.535-1.69-2.817-1.904a4.56 4.56 0 0 0-5.048 0"
    }, null, -1)
  ])))
}
export default { render: render }